





























































































































































































import Vue from 'vue';
import Modal from './components/Modal.vue';
import { ReservationEntity, LocationEntity, GetCurrentScanningLocationOptions } from '../../types';

export default Vue.extend({
  name: 'app',
  components: {
    Modal,
  },
  data() {
    return {
      isLogoutModalShown: false,
      newDataInterval: 0,
      newDataIntervalSeconds: 300, // 5 minutes
    };
  },
  created() {
    this.newDataInterval = setInterval(async () => {
      if ((this as any).currentLocationId && (this as any).currentLocationSecurityScanningCode) {
        const options: GetCurrentScanningLocationOptions = {
          apiKey: (this as any).apiKey,
          customerId: (this as any).customerId,
          locationId: (this as any).currentLocationId,
          securityScanningCode: (this as any).currentLocationSecurityScanningCode,
        };

        await this.$store.dispatch('appData/GET_CURRENT_SCANNING_LOCATION', options);

        this.$store.commit('appData/SET_CURRENT_SCANNING_LOCATION_ENTRANCE', (this as any).currentLocationEntranceId);
      }
    }, this.newDataIntervalSeconds * 1000);
  },
  computed: {
    onLoginPage(): boolean {
      return this.$route.name === 'login';
    },
    onQueue(): boolean {
      return this.$route.name === 'queue';
    },
    cssProps(): any {
      return {
        '--primary-color': (this as any).primaryColor,
        '--primary-font-color': (this as any).primaryFontColor,
        '--primary-button-font-color': (this as any).primaryButtonFontColor,
        '--second-color': (this as any).secondColor,
        '--second-font-color': (this as any).secondFontColor,
        '--second-button-font-color': (this as any).secondButtonFontColor,
        '--header-background-color': (this as any).headerBackgroundColor,
        '--approve-color': (this as any).approveColor,
        '--deny-color': (this as any).denyColor,
      };
    },
    logoSrc(): string {
      const currentLocationLogoURL =
        (this as any).currentLocation && (this as any).currentLocation.logoURL ? (this as any).currentLocation.logoURL : null;

      const locationsLogoURL =
        (this as any).locations && (this as any).locations[0] && (this as any).locations[0].logoURL ? (this as any).locations[0].logoURL : null;

      return currentLocationLogoURL || locationsLogoURL || '/logo.svg';
    },
  },
  methods: {
    signOut(): void {
      this.isLogoutModalShown = false;

      this.$store.commit('appData/REMOVE_LOGIN_DATA');

      this.$router.push({ name: 'login' });
    },
  },
  beforeDestroy() {
    clearInterval(this.newDataInterval);
  },
});
